import *  as ActionTypes from "./tagActionType";

const initialState = {
    isLoading: false,
    isSaved: false,
    tags: []
};

export const tagReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.GET_TAG:
            return {
                ...state,
                isLoading: true,
            }
        case ActionTypes.GET_TAG_FAILURE:
            return {
                ...state,
                isLoading: false,
            }
        case ActionTypes.GET_TAG_SUCCESS:
            return {
                ...state,
                isLoading: false,
                tags: action?.payload?.data || []
            }
        default:
            return state

    }
}